import { render, staticRenderFns } from "./SuggestionUndoBanner.vue?vue&type=template&id=60222fd0&scoped=true"
import script from "./SuggestionUndoBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionUndoBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SuggestionUndoBanner.vue?vue&type=style&index=0&id=60222fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60222fd0",
  null
  
)

export default component.exports